import type { Types as IdunSoftTypes } from '../types';
import type { OutTypes } from './schedules';

export default (courses: IdunSoftTypes.course[]): OutTypes.course[] => {
  return courses
    .reduce<OutTypes.course[]>((acc, course, index) => {
      const ids = course['Ämne'];
      if (!ids)
        throw new Error('A course does not have a unique key');

      if (acc.map(x => x.ids).includes(ids))
        throw new Error(`A course ID "${ids}" exists multiple times at indices ${ index } and ${ acc.findIndex(x => x.ids == ids) }`);

      return acc.concat({
        ids:     ids,
        subject: course['Betygskod']
      });
    }, []);
};